// ---- Notification API ----

export interface NotificationDto {
  id: string;
  type: string; // "AccessRequested" | "AccessApproved" | "AccessRejected"
  title: string;
  message: string;
  relatedEntityId: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationListResponse {
  notifications: NotificationDto[];
  unreadCount: number;
}

export interface UnreadCountResponse {
  count: number;
}

export const fetchNotifications = async (): Promise<NotificationListResponse> => {
  const response = await fetch("/api/notifications", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error(`Failed to fetch notifications: ${response.status}`);
  return response.json();
};

export const fetchUnreadCount = async (): Promise<number> => {
  const response = await fetch("/api/notifications/unread-count", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error(`Failed to fetch unread count: ${response.status}`);
  const data: UnreadCountResponse = await response.json();
  return data.count;
};

export const markNotificationRead = async (notificationId: string): Promise<void> => {
  const response = await fetch(`/api/notifications/${encodeURIComponent(notificationId)}/read`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error(`Failed to mark notification as read: ${response.status}`);
};

export const markAllNotificationsRead = async (): Promise<void> => {
  const response = await fetch("/api/notifications/read-all", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error(`Failed to mark all notifications as read: ${response.status}`);
};

export const clearAllNotifications = async (): Promise<void> => {
  const response = await fetch("/api/notifications", {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error(`Failed to clear notifications: ${response.status}`);
};
